import React from "react";
import {
  BrowserRouter as Router,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import AuthProvider from "./app-context/AuthContext";
import MovieProvider from "./app-context/MovieContext";
import Header from "./components/Header";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Watchlist from "./components/movie/Watchlist";

const router = createBrowserRouter([
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/watchlist", element: <Watchlist /> },
]);
const App = () => {
  return (
    <AuthProvider>
      <MovieProvider>
        <RouterProvider router={router} />
      </MovieProvider>
    </AuthProvider>
  );
};

export default App;
